<main>
  <app-hero></app-hero>
  <app-galerija-o-nama></app-galerija-o-nama>
  <app-specijaliteti></app-specijaliteti>
  <app-contact-form></app-contact-form>
</main>
